
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nha-tuyen-dung/[companyName]",
      function () {
        return require("private-next-pages/nha-tuyen-dung/[companyName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nha-tuyen-dung/[companyName]"])
      });
    }
  